import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export function LoadingScreen() {
  return (
    <Box
      sx={{
        right: 0,
        bottom: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        position: "fixed",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        background: "linear-gradient(79deg, #6B35AD 0%, #28083B 100%)",
      }}
    >
      <Box
        component="img"
        src="/logo.png"
        sx={{
          width: 200,
          mb: 5,
          filter: "brightness(0) invert(1)", // Make logo white for the dark background
        }}
      />
      <CircularProgress sx={{ color: "white" }} />
    </Box>
  );
}
